import {
  createReturnContext,
  type ElyonLaunchContext,
  type ElyonModeEvidence,
  type ElyonReturnContext,
  validateElyonLaunchContext,
  validateModeResultEnvelope,
} from './elyonProductContract'

export const ELYON_LAUNCH_PARAM = 'elyonLaunch' as const
export const ELYON_MODE_RESULT_PARAM = 'elyonModeResult' as const
export const ELYON_CORRELATION_PARAM = 'elyonCorrelationId' as const

export function readElyonLaunchContext(search:string):ElyonLaunchContext|null {
  const raw=new URLSearchParams(search).get(ELYON_LAUNCH_PARAM)
  if(!raw)return null
  let value:unknown
  try{value=JSON.parse(raw)}catch{return null}
  if(!value||typeof value!=='object'||Array.isArray(value))return null
  const launch=value as ElyonLaunchContext
  if(validateElyonLaunchContext(launch).length>0||!launch.returnTo)return null
  return launch
}
export function createFightReturnEnvelope(
  launch:ElyonLaunchContext,
  outcome:ElyonReturnContext['outcome'],
  endedAt:string,
  matchRef:string,
):ElyonReturnContext {
  const evidence:ElyonModeEvidence[]=[
    {kind:'build',ref:launch.buildId},
    {kind:'match',ref:matchRef},
  ]
  return createReturnContext(launch,outcome,endedAt,evidence)
}

export function buildModeResultReturnUrl(
  launch:ElyonLaunchContext,
  envelope:ElyonReturnContext,
  baseHref:string,
):string {
  if(!launch.returnTo)throw new Error('Missing Elyon returnTo')
  const launchErrors=validateElyonLaunchContext(launch)
  if(launchErrors.length)throw new Error(`Invalid Elyon launch context: ${launchErrors.join(',')}`)
  const resultErrors=validateModeResultEnvelope(envelope)
  if(resultErrors.length)throw new Error(`Invalid Elyon mode result envelope: ${resultErrors.join(',')}`)
  if(envelope.accountId!==launch.accountId||envelope.characterId!==launch.characterId||envelope.buildId!==launch.buildId){
    throw new Error('Mode result lineage does not match launch context')
  }
  const target=new URL(launch.returnTo,baseHref)
  if(target.protocol!=='http:'&&target.protocol!=='https:')throw new Error('Unsupported Elyon return protocol')
  target.searchParams.set(ELYON_MODE_RESULT_PARAM,JSON.stringify(envelope))
  if(launch.correlationId)target.searchParams.set(ELYON_CORRELATION_PARAM,launch.correlationId)
  return target.toString()
}

export function navigateModeResultReturn(
  launch:ElyonLaunchContext,
  envelope:ElyonReturnContext,
  location:Pick<Location,'href'|'assign'>=window.location,
):string {
  const target=buildModeResultReturnUrl(launch,envelope,location.href)
  location.assign(target)
  return target
}
